import { Lock } from 'lucide-react'

export function ForbiddenOverlay() {
  return (
    <div className="flex-1 flex items-center justify-center themed-text-muted">
      <div className="text-center">
        <Lock size={32} className="mx-auto mb-2 opacity-40" />
        <p className="text-sm">You no longer have access to this file.</p>
      </div>
    </div>
  )
}
